/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.patient-master-data-wireframe {
  @include mixins.page-grid-basics;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto auto;
  grid-template-areas:
    'patient-data patient-data patient-data '
    '. . . '
    'mission mission mission';
}

.patient-data {
  grid-area: patient-data;
}
.mission {
  grid-area: mission;
  .row div {
    width: 100%;
  }
}

.legend-with-save.row {
  justify-content: space-between;
  align-items: center;

  .indicator {
    width: 30px;
    height: 15px;
    background-color: variables.$color-system-blue-lightest;
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 5px;
  }
}
